import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { WalletCard, RedeemSheet } from '@/components/wallet'

export const Route = createFileRoute('/_app/playground-premium')({
  component: PlaygroundPremiumPage,
})

function PlaygroundPremiumPage() {
  const [balance, setBalance] = useState(127.5)
  const [subscriptionValue, setSubscriptionValue] = useState(89.9)
  const [isSubscriber, setIsSubscriber] = useState(true)
  const [isRedeemOpen, setIsRedeemOpen] = useState(false)

  const handleRedeemSuccess = () => {
    setTimeout(() => {
      setBalance((prev) =>
        Math.max(0, prev - (isSubscriber ? Math.min(prev, subscriptionValue) : prev))
      )
    }, 500)
  }

  return (
    <div className="min-h-screen bg-zinc-50">
      <div className="max-w-5xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          {/* <h1 className="text-2xl font-semibold text-zinc-900 mb-1">Wallet Experience</h1>
          <p className="text-zinc-500 text-sm">Hover the card for 3D effect</p> */}
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start justify-center">
          {/* Controls */}
          <div className="w-full lg:w-56 space-y-5">
            <div className="space-y-4">
              <label className="flex items-center justify-between">
                <span className="text-sm text-zinc-600">Assinante</span>
                <button
                  onClick={() => setIsSubscriber(!isSubscriber)}
                  className={`w-11 h-6 rounded-full transition-colors ${
                    isSubscriber ? 'bg-emerald-500' : 'bg-zinc-300'
                  }`}
                >
                  <div
                    className={`w-5 h-5 rounded-full bg-white shadow-sm transition-transform ${
                      isSubscriber ? 'translate-x-5' : 'translate-x-0.5'
                    }`}
                  />
                </button>
              </label>

              <div className="space-y-1.5">
                <label className="text-sm text-zinc-600">Saldo</label>
                <input
                  type="number"
                  value={balance}
                  onChange={(e) => setBalance(Number(e.target.value))}
                  className="w-full h-10 px-3 rounded-lg bg-white border border-zinc-200 text-zinc-800 text-sm focus:outline-none focus:border-zinc-400 focus:ring-1 focus:ring-zinc-400"
                />
              </div>

              {isSubscriber && (
                <div className="space-y-1.5">
                  <label className="text-sm text-zinc-600">Assinatura</label>
                  <input
                    type="number"
                    value={subscriptionValue}
                    onChange={(e) => setSubscriptionValue(Number(e.target.value))}
                    className="w-full h-10 px-3 rounded-lg bg-white border border-zinc-200 text-zinc-800 text-sm focus:outline-none focus:border-zinc-400 focus:ring-1 focus:ring-zinc-400"
                  />
                </div>
              )}
            </div>

            {/* Quick actions */}
            <div className="flex gap-2">
              <button
                onClick={() => setBalance((b) => b + 50)}
                className="flex-1 h-9 rounded-lg bg-white border border-zinc-200 text-zinc-600 text-sm hover:bg-zinc-50 transition-colors"
              >
                +50
              </button>
              <button
                onClick={() => setBalance(0)}
                className="flex-1 h-9 rounded-lg bg-white border border-zinc-200 text-zinc-600 text-sm hover:bg-zinc-50 transition-colors"
              >
                Reset
              </button>
            </div>

            <button
              onClick={() => setBalance(subscriptionValue)}
              className="w-full h-9 rounded-lg bg-white border border-zinc-200 text-zinc-600 text-sm hover:bg-zinc-50 transition-colors"
            >
              = Assinatura
            </button>
          </div>

          {/* Card */}
          <div className="flex-1 flex justify-center pt-4">
            <WalletCard
              balance={balance}
              subscriptionValue={subscriptionValue}
              isSubscriber={isSubscriber}
              referralCode="NUT-RAFO-X92"
              onRedeem={() => setIsRedeemOpen(true)}
            />
          </div>
        </div>
      </div>

      <RedeemSheet
        open={isRedeemOpen}
        onOpenChange={setIsRedeemOpen}
        balance={balance}
        subscriptionValue={subscriptionValue}
        isSubscriber={isSubscriber}
        onSuccess={handleRedeemSuccess}
      />
    </div>
  )
}
